import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  banner: {
    background: theme.white,
    display: 'flex',
    flexFlow: 'row nowrap',
    width: '100%',
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '12px 16px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.other.spacing._16,
    borderRadius: theme.radius.md,

    '&.info': {
      color: theme.colors.blue[7],
      background: `${theme.colors.blue[3]}26`,
    },
    '&.warning': {
      color: theme.colors.yellow[7],
      background: `${theme.colors.yellow[3]}26`,
    },
    '&.error': {
      color: theme.colors.red[7],
      background: `${theme.colors.red[3]}26`,
    },
    '&.success': {
      color: theme.colors.green[7],
      background: `${theme.colors.green[3]}26`,
    },

    '&.hasShadow': {
      boxShadow: `0 8px 40px 0 ${theme.black}1A`,
    },
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'inherit',
  },
  content: {
    display: 'flex',
    flexFlow: 'column nowrap',
    color: theme.colors.gray2[6],
    width: '100%',

    '& a, & a:visited': {
      color: 'inherit',
      textDecoration: 'underline',
      fontWeight: 700,

      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
}));

export default useStyles;
